module.exports = __webpack_public_path__ + "static/img/ic_splash.c93a285.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_splash.png
// module id = nmWj
// module chunks = 1